
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class LocationTransferItemsSelectGrid extends _Ext.GridBase<LocationTransferItemsRow,any> {
        protected getColumnsKey() { return 'Inventory.LocationTransferItemsSelect'; }
        protected getDialogType() { return <any>LocationTransferItemsDialog; }
        protected getIdProperty() { return LocationTransferItemsRow.idProperty; }
        protected getLocalTextPrefix() { return LocationTransferItemsRow.localTextPrefix; }
        //protected getInsertPermission() { return LocationTransferItemsRow.insertPermission; }
        //protected getUpdatePermission() { return LocationTransferItemsRow.updatePermission; }
        //protected getDeletePermission() { return LocationTransferItemsRow.deletePermission; }
        //protected useViewMode() { return true; } 
     
        constructor(container: JQuery, options) {
            super(container, options);           
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;

        //protected createSlickGrid(): Slick.Grid {
        //    let grid = super.createSlickGrid();
        //    let x;
        //    LocationTransferItemsService.CustomList({
        //        ContainsText: LocationTransferItemsSelectGrid.ledgerId.toString()
        //    },
        //        response =>
        //            x = response,
        //        { async: false });          

           
        //    for (let rateitem of x.Entities) {
        //        rateitem[this.getIdProperty()] = rateitem.TransItemId;
        //        //   alert('ID ' + rateitem.CostId);

        //        this.view.addItem(rateitem);
        //    }
        //    //grid.setData(x1, true);
        //    //var c = grid.getData();
            
        //    return grid;
        //}

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): LocationTransferItemsRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    }
     
}